export default {"src":"/_next/static/media/instagram.c97e4f90.svg","height":37,"width":38,"blurWidth":0,"blurHeight":0};